import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { SpinnerIcon } from '../icons';
import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { useTranslation } from 'react-i18next';

type LoadableProps = {
  isLoading: boolean;
  loadingMessage?: TranslationKeys;
  className?: string;
  spinnerClassName?: string;
  messageClassName?: string;
} & PropsWithChildren;

export const Loadable: FC<LoadableProps> = ({ isLoading, loadingMessage, className, spinnerClassName, messageClassName, children }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={twMerge('flex grow items-center justify-center', loadingMessage && 'flex-col gap-1.5', className)}>
        <SpinnerIcon className={twMerge('size-6', spinnerClassName)} loading />
        {loadingMessage && (
          <p className={twMerge('text-sm font-medium text-quaternary-500', messageClassName)}>{t(toRuntimeTranslationKey(loadingMessage) as any)}</p>
        )}
      </div>
    );
  }

  return children;
};
